import React from 'react';
import { ArrowRight, Clock, AlertTriangle, Check, ShieldCheck, Zap } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full" data-id="element-249">
      {/* Hero Header */}
      <div className="bg-navy text-white pt-12 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-250">
        <div className="max-w-4xl mx-auto text-center" data-id="element-251">
          <div className="inline-block bg-brandRed text-white font-bold px-4 py-1 rounded-full text-sm sm:text-base mb-6 uppercase tracking-wider" data-id="element-252">
            Página de Ventas Oficial
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black mb-6 leading-tight" data-id="element-253">
            ¿Cansado de Pagar con tu Espalda el{' '}
            <span className="text-brandGold" data-id="element-254">"Sueño Americano"</span>?
          </h1>

          <p className="text-xl sm:text-2xl font-medium mb-8 text-gray-300 leading-relaxed" data-id="element-255">
            Descubre Cómo Pasar de Trabajos Físicos a una Carrera en Tecnología
            en 90 Días… Sin Título Universitario y Sin Inglés Perfecto.
          </p>

          {/* Quick Value Summary */}
          <div className="max-w-md mx-auto bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 mb-10 text-left" data-id="element-256">
            <h3 className="font-bold text-white text-lg mb-4 text-center" data-id="element-257">
              Lo que recibes hoy por $6,39:
            </h3>
            <ul className="space-y-3 mb-6 text-sm" data-id="element-258">
              <li className="flex items-center text-white" data-id="element-259">
                <Check className="w-5 h-5 text-green-400 mr-2 flex-shrink-0" data-id="element-260" />
                <span data-id="element-261">Guía Maestra RUTA IT USA ($27)</span>
              </li>
              <li className="flex items-center text-white" data-id="element-262">
                <Check className="w-5 h-5 text-green-400 mr-2 flex-shrink-0" data-id="element-263" />
                <span data-id="element-264">Checklist 90 Días a IT ($17 gratis)</span>
              </li>
              <li className="flex items-center text-white" data-id="element-265">
                <Check className="w-5 h-5 text-green-400 mr-2 flex-shrink-0" data-id="element-266" />
                <span data-id="element-267">Guion de Entrevista Hispano a Prueba ($18 gratis)</span>
              </li>
              <li className="flex items-center text-white" data-id="element-268">
                <Check className="w-5 h-5 text-green-400 mr-2 flex-shrink-0" data-id="element-269" />
                <span data-id="element-270">Plantilla Resume ATS 1 Página ($17 gratis)</span>
              </li>
            </ul>
            <div className="text-center border-t border-white/20 pt-4" data-id="element-271">
              <p className="text-gray-400 text-sm line-through mb-1" data-id="element-272">
                Total valor real: $79
              </p>
              <p className="text-brandGold font-black text-lg mb-3" data-id="element-273">
                OFERTA SOLO HOY $6,39
              </p>
              <div className="flex justify-center gap-4 text-xs text-gray-300" data-id="element-274">
                <span className="flex items-center" data-id="element-275">
                  <ShieldCheck className="w-3 h-3 mr-1" data-id="element-276" /> Garantía 30 días
                </span>
                <span className="flex items-center" data-id="element-277">
                  <Zap className="w-3 h-3 mr-1" data-id="element-278" /> Descarga inmediata
                </span>
              </div>
            </div>
          </div>

          <div className="bg-navy-700 border border-brandBlue/30 rounded-xl p-6 mb-10 shadow-lg" data-id="element-279">
            <p className="text-lg sm:text-xl font-medium text-white" data-id="element-280">
              Miles de hispanos en EE.UU. ya están usando las Certificaciones
              Profesionales de Google para entrar al mundo corporativo y ganar
              entre{' '}
              <strong className="text-brandGold" data-id="element-281">
                $50,000 y $90,000 al año
              </strong>
              . Esta guía te muestra exactamente cómo hacerlo.
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-12" data-id="element-282">
            <img src="https://cdn.magicpatterns.com/uploads/vk7UE1GJkXFNR7EbPxg3y8/PORTADA_3.png" alt="Ruta IT USA - El Salto de $0 a $70k" className="w-full max-w-md rounded-lg shadow-2xl border-4 border-navy-700" data-id="element-283" />
          </div>

          <a href="#comprar" className="inline-flex items-center justify-center bg-brandRed hover:bg-brandRed-600 text-white font-bold text-xl py-4 px-8 rounded-lg transition-colors duration-200 shadow-[0_4px_14px_0_rgba(229,62,62,0.39)] w-full sm:w-auto" data-id="element-284">
            SÍ, QUIERO EL SALTO DE $0 A $70K — SOLO $6,39
            <ArrowRight className="ml-2 h-6 w-6" data-id="element-285" />
          </a>
        </div>
      </div>

      {/* Opening Hook (Story of Pain) */}
      <div className="bg-white py-16 px-4 sm:px-6 lg:px-8 border-b border-gray-200" data-id="element-286">
        <div className="max-w-3xl mx-auto" data-id="element-287">
          <div className="flex items-center justify-center mb-8" data-id="element-288">
            <Clock className="h-10 w-10 text-brandRed mr-4" data-id="element-289" />
            <h2 className="text-3xl font-bold text-navy" data-id="element-290">
              Son las 8:00 PM de un domingo.
            </h2>
          </div>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-291">
            <p data-id="element-292">
              Te duele la espalda. Las manos están ásperas. El almuerzo estuvo
              frío y el jefe ni las gracias te dio.
            </p>
            <p className="font-semibold text-navy" data-id="element-293">
              Mañana, lunes a las 5:00 AM, suena la alarma y vuelves a empezar.
            </p>
            <p data-id="element-294">
              Llegaste a este país con un sueño. Con hambre de progresar. Con
              inteligencia y disciplina que muchos no tienen. Pero el sistema te
              puso donde le convenía: cargando, limpiando, construyendo… sin un
              techo al que llegar.
            </p>
            <div className="bg-red-50 border-l-4 border-brandRed p-6 mt-8" data-id="element-295">
              <p className="text-xl font-bold text-navy m-0" data-id="element-296">
                La pregunta no es si mereces más. La pregunta es:{' '}
                <span className="text-brandRed" data-id="element-297">
                  ¿cuándo vas a hacer algo diferente?
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}